<template>
  <div>
    <v-dialog v-model="dialogInfoPlan" scrollable width="450px">
      <v-card>
        <v-card-title>
          <span class="headline"><strong>Dados do Plano</strong></span>
          <v-tooltip bottom>
            <v-btn slot="activator" icon style="right: 0; top: 0; position: absolute" fab @click="dialogInfoPlan = false">
              <v-icon color="black">close</v-icon>
            </v-btn>
            <span>Fechar</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="last-payment-container">
            <v-layout row wrap justify-space-between>    
              <v-flex xs6 class="p-flex-plan"> 
                <span class="p-label-plan">Plano:</span>
              </v-flex> 
              <v-flex xs6 class="p-flex-plan"> 
                <p class="p-content-plan break-word">{{checkIsFree() ? 'Grátis' : getterPlan['id_text']}}</p>
              </v-flex>
              <v-flex xs6 class="p-flex-plan">   
                <span class="p-label-plan">Usuários:</span>
              </v-flex>   
              <v-flex xs6 class="p-flex-plan">   
                <p v-if="planValues['qtdUserPlan'] > 0" class="p-content-plan break-word" :style="'color: ' + (planValues['qtdCompanyUser'] >= planValues['qtdUserPlan'] ? 'darkred' : 'darkgreen')">{{planValues['qtdCompanyUser']}} / {{planValues['qtdUserPlan']}}</p>
                <p v-else class="p-content-plan break-word" :style="'color: darkgreen'">{{planValues['qtdCompanyUser']}} / Ilimitado</p>
              </v-flex>
              <v-flex xs6 class="p-flex-plan"> 
                <span class="p-label-plan">Memória:</span>
              </v-flex> 
              <v-flex xs6 class="p-flex-plan"> 
                <p v-if="planValues['qtdSizePlan'] > 0" class="p-content-plan break-word" :style="'color: ' + (planValues['sumMemoryFiles'] >= planValues['qtdSizePlan'] ? 'darkred' : 'darkgreen')">{{(planValues['sumMemoryFiles']/1000000).toFixed(2)}} / {{(planValues['qtdSizePlan']/1000000).toFixed(2)}} MB</p>
                <p v-else class="p-content-plan break-word" :style="'color: darkgreen'">{{(planValues['sumMemoryFiles']/1000000).toFixed(2)}} / Ilimitado MB</p>
              </v-flex>
              <v-flex xs6 class="p-flex-plan" v-if="planValues['infoPayment'] && planValues['infoPayment']['last_bill'].length > 0">
                <span class="p-label-plan">Status:</span>
              </v-flex>
              <v-flex xs6 class="p-flex-plan" v-if="planValues['infoPayment'] && planValues['infoPayment']['last_bill'].length > 0">
                <p class="p-content-plan break-word" :style="'color: ' + (getColorStatus(planValues['infoPayment']['last_bill'][0]['payment_status']))">{{ getStatus(planValues['infoPayment']['last_bill'][0]['payment_status']) }}</p>
              </v-flex>
              <v-flex xs6 class="p-flex-plan" v-if="planValues['infoPayment'] && planValues['infoPayment']['last_bill'].length > 0">   
                <span class="p-label-plan">Expiração do Plano:</span>
              </v-flex>   
              <v-flex xs6 class="p-flex-plan" v-if="planValues['infoPayment'] && planValues['infoPayment']['last_bill'].length > 0">
                <p class="p-content-plan break-word" :style="'color: ' + (getColorActiveStatus(planValues['infoPayment']['last_bill'][0]['expired']))">{{planValues['infoPayment']['last_bill'][0]['expired'] | formatDate}}</p>
              </v-flex>
              <v-flex xs6 class="p-flex-plan" v-if="planValues['infoPayment'] && planValues['infoPayment']['payment_method']">
                <span class="p-label-plan">Método de Pagamento:</span>
              </v-flex>
              <v-flex xs6 class="p-flex-plan" v-if="planValues['infoPayment'] && planValues['infoPayment']['payment_method']">
                <p class="p-content-plan break-word">{{getPaymentMethod(planValues['infoPayment']['payment_method'])}}</p>
              </v-flex>
              <v-flex xs12>
                <v-layout v-if="checkIsFree()" row wrap justify-center align-center>
                  <v-btn block outline to="upgrade" @click="dialogInfoPlan = false" large color="#ffc107">
                    <img src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px"> &nbsp; Fazer Upgrade
                  </v-btn>
                </v-layout>
                <v-layout v-else row wrap justify-center align-center>
                  <v-btn flat color="primary" @click="clickMigratePlan">Migrar de Plano</v-btn>
                  <v-btn flat color="primary" :to="'/company/' + $auth.user().company_id + '?tab=2'" @click="dialogInfoPlan = false">Visualizar Faturas</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="dialogInfoPlan = false">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="migratePlan" scrollable width="400px">
      <v-card justify-center>
        <v-card-title>
          <span class="headline"><strong>Migrar de plano!</strong></span>
          <v-tooltip bottom>
            <v-btn slot="activator" icon style="right: 0; top: 0; position: absolute" fab @click="migratePlan = false">
              <v-icon color="black">close</v-icon>
            </v-btn>
            <span>Fechar</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap justify-center align-center>
            <div class="last-payment-container">
              <div class="last-payment-body">
                <div class="text-column">
                  <h3>Entre em contato com nosso suporte ao lado ou pelas opções abaixo!</h3>
                  <br>
                  <span><strong>Telefone: </strong><strong style="color: blue;">(34) 99910-0135</strong></span>
                  <span><strong>Email: </strong><strong style="color: blue;">suporte.sistema@illissolucoes.com.br</strong></span>
                </div>
              </div>
            </div>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="migratePlan = false">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import plan from '../../mixin/plan'
  import planLayout from '../../mixin/planLayout'
  export default {
    name: 'PInfoPlan',
    mixins: [plan, planLayout],
    props: {
    },
    data: function () {
      return {
        migratePlan: false,
        dialogInfoPlan: false,
        planValues: {
          qtdUserPlan: '',
          qtdSizePlan: '',
          qtdCompanyUser: '',
          sumMemoryFiles: '',
          infoPayment: null
        }
      }
    },
    methods: {
      clickPlan () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.get('api/get_info_plan').then(result => {
          this.$store.commit('loader/change_dialog', false)
          // Busca quantidade de usuários tem cadastrados na empresa
          // Busca o somatorio de todos os arquivos da empresa logada
          // Busca Informações Complementares do Plano, como: status, método de pagamento e expiração do plano
          this.planValues = result.body
          // Busca a quantiidade de usuarios tem a empresa
          let plan = this.getterAccesses.find((res) => {
            return (res.id_text === 'company_user' && res.hasOwnProperty('qtd'))
          })
          this.planValues.qtdUserPlan = 'Ilimitado'
          if (plan) this.planValues.qtdUserPlan = plan['qtd']
          // Busca a quatidade de memória que o plano permite
          let size = this.getterAccesses.find((res) => {
            return (res.id_text === 'files' && res.hasOwnProperty('size'))
          })
          let sumSizeFiles = 0
          if (size) sumSizeFiles = size['size']
          this.planValues.qtdSizePlan = sumSizeFiles
          this.dialogInfoPlan = true
        },
        err => {
          this.$store.commit('loader/change_dialog', false)
          console.log(err)
          this.taskLoading = false
          this.$store.commit('snackbar/change_values', {
            text: 'Registros não foram carregados corretamente! Reporte o erro!',
            color: 'error',
            dialog: true
          })
        })
      },
      clickMigratePlan () {
        document.getElementById('purechat-btn').click()
        this.migratePlan = true
      }
    }
  }
</script>

<style scoped>
  .last-payment-container{
    border: 2px solid #00acc2;
    border-radius: 10px;
    padding: 20px;
  }

  .last-payment-body{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
  }
  
  .p-flex-plan {
    height: 34px;
  }
  
  .p-label-plan {
    font-size: 11pt;
    color: #1d1d1d;
    font-weight: 600;
    padding-left: 8px;
  }

  .p-content-plan {
    font-size: 12pt;
    text-align: right;
    margin-bottom: 0;
    white-space: pre-line;
    /* font-weight: 600; */
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/PInfoPlan.vue